import image2base64 from 'image-to-base64';
import jsPDF from 'jspdf';
import { qrCodeApi } from '../services/api';
import gloriaLogo from "../assets/weblogo.png"


let gloriaLogo64 = '';
image2base64(gloriaLogo).then(r => gloriaLogo64 = r);

function getBase64(url) {
  return qrCodeApi
    .get(url, {
      responseType: 'arraybuffer'
    })
    .then(response => Buffer.from(response.data, 'binary').toString('base64'))
}

export default async function jsPdfGenerator(name, cpf, nis, family_count, ocupation, address, birthday, contact, neighborhood, status, user) {
  
  // let qrImage64 = await getBase64(`?data=${cpf}&size=150x150&format=png`);
  
  let doc = new jsPDF('p', 'pt');

  doc.addImage(gloriaLogo64, 'PNG', 190, 80, 200, 100, 'al', 'NONE');
  
  doc.setFont('helvetica')
  
  doc.setFontType("bold");
  doc.setFontSize(22);
  doc.text(130, 50, 'COMPROVANTE DE INSCRIÇÃO')
  
  // doc.addImage(qrImage64, 'PNG', 430, 310, 100, 100, 'all', 'NONE');



  doc.setFontType("bold");
  doc.setFontSize(18);
  doc.text(220, 220, 'PEIXE SOLIDÁRIO')


  doc.setFontType("bold");
  doc.setFontSize(14);
  doc.text(165, 245, 'Prefeitura Municipal de Glória do Goitá')


  doc.setFontType("bold");
  doc.setFontSize(12);
  doc.text(40, 330, 'NOME: ')

  doc.setFontType("normal");
  doc.setFontSize(12);
  doc.text(83, 330, `${name.toUpperCase()}`)

  doc.setFontType("bold");
  doc.setFontSize(12);
  doc.text(40, 350, 'CPF: ')

  doc.setFontType("normal");
  doc.setFontSize(12);
  doc.text(70, 350, `${cpf}`)

  doc.setFontType("bold");
  doc.setFontSize(12);
  doc.text(40, 370, 'NIS: ')

  doc.setFontType("normal");
  doc.setFontSize(12);
  doc.text(67, 370, `${nis}`)

  doc.setFontType("bold");
  doc.setFontSize(12);
  doc.text(40, 390, 'DATA DE NASCIMENTO: ')

  doc.setFontType("normal");
  doc.setFontSize(12);
  doc.text(184, 390, `${birthday}`)

  doc.setFontType("bold");
  doc.setFontSize(12);
  doc.text(40, 410, 'ESTADO CIVIL: ')

  doc.setFontType("normal");
  doc.setFontSize(12);
  doc.text(130, 410, `${status.toUpperCase()}`)

  doc.setFontType("bold");
  doc.setFontSize(12);
  doc.text(40, 430, 'OCUPAÇÃO: ')

  doc.setFontType("normal");
  doc.setFontSize(12);
  doc.text(116, 430, `${ocupation.toUpperCase()}`)

  doc.setFontType("bold");
  doc.setFontSize(12);
  doc.text(40, 450, 'Nº DE FAMILIARES: ')

  doc.setFontType("normal");
  doc.setFontSize(12);
  doc.text(157, 450, `${family_count.toUpperCase()}`)

  doc.setFontType("bold");
  doc.setFontSize(12);
  doc.text(40, 470, 'CONTATO: ')

  doc.setFontType("normal");
  doc.setFontSize(12);
  doc.text(107, 470, `${contact}`)

  doc.setFontType("bold");
  doc.setFontSize(12);
  doc.text(40, 490, 'ENDEREÇO: ')

  doc.setFontType("normal");
  doc.setFontSize(12);
  doc.text(115, 490, `${address.toUpperCase()}`)

  doc.setFontType("bold");
  doc.setFontSize(12);
  doc.text(40, 510, 'BAIRRO: ')

  doc.setFontType("normal");
  doc.setFontSize(12);
  doc.text(95, 510, `${neighborhood.toUpperCase()}`)

  doc.setFontType("bold");
  doc.setFontSize(12);
  doc.text(40, 540, 'CADASTRANTE: ')

  doc.setFontType("normal");
  doc.setFontSize(12);
  doc.text(140, 540, `${user.toUpperCase()}`)

  doc.setFontType("bold");
  doc.setFontSize(18);
  doc.text(260, 590, 'RECIBO')

  doc.setFontType("normal");
  doc.setFontSize(12);
  doc.fromHTML(`<div style="max-width: 600px"><p style="word-break: break-word;">Eu, 
  <b>${name.toUpperCase()}</b>, sob o CPF de Nº <b>${cpf.toUpperCase()}</b>, residente 
  no endereço <b>${address.toUpperCase()}</b>, Confirmo o recebimento do benefício do 
  peixe de acordo com a Lei Municipal de <b>Nº 1.196 / 2017</b>.</p></div>`, 45, 600, { width: 500 });

  doc.setFontType("bold");
  doc.setFontSize(12);
  doc.text(150, 685, `___________________________________________`)

  doc.setFontType("normal");
  doc.setFontSize(12);
  doc.text(225, 705, `Assinatura do beneficiário`)

  doc.setFontType("bold");
  doc.setFontSize(12);
  doc.text(150, 760, `___________________________________________`)

  doc.setFontType("normal");
  doc.setFontSize(12);
  doc.text(225, 780, `Assinatura do responsável`)


  doc.output('dataurlnewwindow', 'gloria');

};